import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xjywu3etzs: FaireBrandEntity = {
  token: "b_xjywu3etzs",
  type: "brand",
  name: "Element Brooklyn",
  avatarUrl:
    "https://cdn.faire.com/fastly/0199d667938ee38683f4c4bef0537a40d3a79f04c161b7cb69225d3dcd26dd2b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c21fdbc2948a3d9939450a36b20a319e336763de9c53ed12d4497ab89c430f01.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0199d667938ee38683f4c4bef0537a40d3a79f04c161b7cb69225d3dcd26dd2b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c21fdbc2948a3d9939450a36b20a319e336763de9c53ed12d4497ab89c430f01.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 6,
  isTopShop: true,
  isInsider: true,
  description:
    "Our mission at Element Brooklyn is to bring quality formulations and luxurious fragrances into your home – without wasteful packaging and high price tags. Our bestselling soap, cream and candle refills match the quality and fragrance of designer brands but in affordable and eco-friendly packaging formats. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:25.417Z",
    importedBy: "entity-db-cli",
  },
};
